export default {
  title: 'Contacto y sincronización',
  labels: {
    occ_phone_number: 'Número del call center',
    company_phone_number: 'Número del restaurante',
    has_google_business_sync: 'Sincronizar con Google Business',
    has_foodamigos_sync: 'Sincronizar con los servicios de Foodamigos',
  },
  placeholders: {
    occ_phone_number: 'Seleccionar número de la lista',
  },
};
